import Backbone from 'backbone';
import $ from 'jquery'; // eslint-disable-line
import session from '@/models/v5/session';
import IdeApp from '@/ide_app';
import bootstrap from 'bootstrap'; // eslint-disable-line
import bootstrap_css from 'bootstrap/dist/css/bootstrap.min.css'; // eslint-disable-line
import ide_less from 'ide'; // eslint-disable-line
// Output a cute recruiting message to the console like every other startup
if (window.location && window.location.host && window.location.host.indexOf('electricimp.com') !== -1) {
    console.log("Want to help shape the future of IoT? https://electricimp.com/careers/");
}

// Set title
document.title = 'impCentral | Electric Imp';
var app_options = {};
var runtimeConfigModel = Backbone.Model.extend({
    url : '/config.json'
});
var runtime_config = new runtimeConfigModel({});

runtime_config.fetch().then(
    function() {
        for (var key in runtime_config.attributes) {
            app_options[key] = runtime_config.get(key) || {};
        }

        session.load();
        var app = new IdeApp(app_options);
        app.start(app_options);
    }
);

